import {ALL, COMPUTER_KEYBOARD, CUSTOM} from 'constants/midi-input-types.js';

class TrackMidiInputs {
    constructor() {
        // by default, a track accepts inputs from everywhere
        this.type = ALL;
        this.nameToMidiInput = {};
    }

    addMidiInput(input) {
        this.nameToMidiInput[input.name] = input;
        this.type = CUSTOM;
    }

    deleteMidiInput(input) {
        if (input.name in this.nameToMidiInput) {
            delete this.nameToMidiInput[input.name];
            if (Object.keys(this.nameToMidiInput).length === 0) {
                this.type = ALL;
            }
        }
    }

    setType(type) {
        if (type === ALL || type === COMPUTER_KEYBOARD) {
            this.nameToMidiInput = {};
        }

        this.type = type;
    }

    accepts(isMidi, inputName) {
        if (this.type === ALL) {
            return true;
        }
        
        if (isMidi) {
            return inputName in this.nameToMidiInput;
        } else {
            return this.type === COMPUTER_KEYBOARD;
        }
    }

    getMidiInputs() {
        return Object.values(this.nameToMidiInput);
    }

    getMidiInputNames() {
        return Object.keys(this.nameToMidiInput);
    }
}

export default TrackMidiInputs;
